/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Supplier API
 * Areeb Supplier REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrderLimitDto
 */
export interface OrderLimitDto {
    /**
     * Time period for the order limit
     * @type {string}
     * @memberof OrderLimitDto
     */
    period: OrderLimitDtoPeriodEnum;
    /**
     * Maximum quantity allowed for this period
     * @type {number}
     * @memberof OrderLimitDto
     */
    maxQuantity: number;
}


/**
 * @export
 */
export const OrderLimitDtoPeriodEnum = {
    Day: 'DAY',
    Week: 'WEEK',
    Month: 'MONTH'
} as const;
export type OrderLimitDtoPeriodEnum = typeof OrderLimitDtoPeriodEnum[keyof typeof OrderLimitDtoPeriodEnum];


/**
 * Check if a given object implements the OrderLimitDto interface.
 */
export function instanceOfOrderLimitDto(value: object): value is OrderLimitDto {
    if (!('period' in value) || value['period'] === undefined) return false;
    if (!('maxQuantity' in value) || value['maxQuantity'] === undefined) return false;
    return true;
}

export function OrderLimitDtoFromJSON(json: any): OrderLimitDto {
    return OrderLimitDtoFromJSONTyped(json, false);
}

export function OrderLimitDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderLimitDto {
    if (json == null) {
        return json;
    }
    return {
        
        'period': json['period'],
        'maxQuantity': json['maxQuantity'],
    };
}

export function OrderLimitDtoToJSON(value?: OrderLimitDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'period': value['period'],
        'maxQuantity': value['maxQuantity'],
    };
}

